import React, { useRef, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Images } from "./../../assets/common";
import { Upload, Calendar, Plus, ChevronDown } from "react-iconly";
import BottomSheet from "../BottomSheet";
import OutsideClick from "./../../components/OutsideClick";
import { useTranslation } from "react-i18next";
export default function DropDown({ title, onChange, values, _class, menuKey }) {
  const { t } = useTranslation("common");
  const [show, setShow] = React.useState(false);
  const [selected, setSelected] = React.useState();
  const toggleDrawer = (newOpen, value) => {
    setShow(newOpen);
    if (!newOpen && value) {
      setSelected(
        value.key ? value.value : value.language ? value.language : value
      );
      onChange(value);
    }
  };
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          toggleDrawer(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  React.useEffect(() => {
    setSelected(title);
  }, [title]);
  return (
    <Box
      ref={wrapperRef}
      onClick={() => toggleDrawer(!show)}
      className={
        (_class
          ? "_playlist_topfive_dropdown_container "
          : "__custom_dropdown_container ") + (show ? " _show_dropdown" : "")
      }
    >
      <Typography sx={{ paddingLeft: "20px" }}>{selected}</Typography>
      <img src={Images.arrowdown} className="__transform" alt="" />

      {show ? (
        // <BottomSheet
        //   open={show}
        //   actions={values ? values : []}
        //   handleOpen={(e, value) => toggleDrawer(e, value)}
        // />
        <Box className="__custom_dropdown">
          {values &&
            values.map((m, index) => (
              <Typography
                key={index}
                className="__custom_dropdown_item fs-14 _cp"
                onClick={(e, value) =>
                  toggleDrawer(
                    false,
                    m["genre"]
                      ? m["genre"]
                      : m["language"]
                      ? m
                      : m["key"]
                      ? m
                      : m
                  )
                }
              >
                {m["genre"]
                  ? m["genre"]
                  : m["language"]
                  ? m["language"]
                  : m["key"]
                  ? m["value"]
                  : m}
              </Typography>
            ))}
        </Box>
      ) : null}
    </Box>
  );
}
